import { useFormattedTerms } from "@faire/retailer-visitor-shared/hooks/openWithFaire/useFormattedTerms";
import { useOpenWithFaireTerms } from "@faire/retailer-visitor-shared/stores/domain/OpenWithFaire/useOpenWithFaireTerms";
export var useFormattedOfferedMaxTerms = function() {
    var offeredMaxTerms = useOpenWithFaireTerms().offeredMaxTerms;
    return useFormattedTerms(offeredMaxTerms);
};
